module.exports = __webpack_public_path__ + "img/target.8933c651.svg";